module.exports = __webpack_public_path__ + "img/icon-facility-w.45a4dfcb.svg";